import { memo } from "react";
import WithDriverIconPopup from "./WithDriverIconPopup";
function DriverAtFuelingMarker({color}) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: "scale(2.0)" }}
    >
      <g filter="url(#filter0_d)">
        <path
          d="M13.2886 5.83721C12.8601 5.3259 12.217 5 11.5 5H7.50002C6.2144 5 5.16669 6.04772 5.16669 7.33333V18C5.16669 18.5523 5.6144 19 6.16669 19H12.8334C13.2589 19 13.6223 18.7342 13.7667 18.3596C14.2329 18.7588 14.8384 19 15.5 19C16.9723 19 18.1667 17.8056 18.1667 16.3333V10C18.1667 9.32943 17.9176 8.71007 17.5066 8.24062C17.4736 8.1934 17.436 8.1484 17.3938 8.10623L14.9138 5.62623C14.5233 5.2357 13.8901 5.2357 13.4996 5.62623L13.2886 5.83721ZM10.5 13V15.6667H8.50002V13H10.5ZM10.5 9.66667H8.50002V8.33333H10.5V9.66667ZM15.5 9.66667C15.6856 9.66667 15.8334 9.81438 15.8334 10C15.8334 10.1856 15.6856 10.3333 15.5 10.3333C15.3144 10.3333 15.1667 10.1856 15.1667 10C15.1667 9.81438 15.3144 9.66667 15.5 9.66667Z"
          fill={color || "#05A792"}
          stroke="white"
          strokeWidth="2"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_d"
          x="-0.5"
          y="0"
          width="24"
          height="24"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export default WithDriverIconPopup(memo(DriverAtFuelingMarker));
